var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"problem-picker"},[_c('AdaptiveSelectorList',{attrs:{"options":_vm.options,"selected-option":_vm.selectedOption},on:{"select":function($event){return _vm.selectOption($event)}},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{staticClass:"problem-picker__item"},[_vm._v(" "+_vm._s(option.label)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }